import { render } from "./market-switcher-trigger.vue?vue&type=template&id=05326b9e"
import script from "./market-switcher-trigger.vue?vue&type=script&lang=js"
export * from "./market-switcher-trigger.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__